<template>
	<div class="card layout__sidebar">
		<div v-show="!isSignUp">
			<div class="card__header">
				<h4 class="card__title text-center">Авторизация</h4>
			</div>
			<div class="fields__item">
				<button @click="$root.OAuth('vkontakte')" class="btn btn--outline btn--vk btn--block">
					<svg class="btn__icon" height="14" width="14">
						<use href="#svg-icon-vk"></use>
					</svg>
					<span>Вконтакте</span>
				</button>
			</div>
			<div class="fields__item fields__row">
				<div class="fields__item">
					<button @click="$root.OAuth('telegram')" class="btn btn--outline btn--tg btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-tg"></use>
						</svg>
						<span>Telegram</span>
					</button>
				</div>
				<div class="fields__item">
					<button @click="$root.OAuth('google')" class="btn btn--outline btn--google btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-google"></use>
						</svg>
						<span>Google</span>
					</button>
				</div>
			</div>
			<div class="fields__item fields__row">
				<div class="fields__item">
					<button @click="$root.OAuth('mailru')" class="btn btn--outline btn--mailru btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-mailru"></use>
						</svg>
						<span>Mail.ru</span>
					</button>
				</div>
				<div class="fields__item">
					<button @click="$root.OAuth('yandex')" class="btn btn--outline btn--yandex btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-yandex"></use>
						</svg>
						<span>Yandex</span>
					</button>
				</div>
			</div>

			<div class="sap-text"><span>Или</span></div>

			<div class="fields__item">
				<input v-model="username" type="text" placeholder="Логин" class="text-field__input"
					@keyup.enter="login">
			</div>

			<div class="fields__item">
				<input v-model="password" type="password" placeholder="Пароль" class="text-field__input"
					@keyup.enter="login">
			</div>

			<div class="fields__item">
				<vue-recaptcha ref="recaptcha" cssClass="google-recaptcha" :sitekey="$root.$reCaptchaSiteKey"
					@verify="onCaptchaVerified" @expired="onCaptchaExpired">
				</vue-recaptcha>
			</div>

			<div v-show="!disableBtn" class="fields__item">
				<button class="btn btn--primary btn--block" type="button" @click="login" :disabled="disableBtn">
					Войти
				</button>
			</div>

			<Loader class="fields__item" v-show="disableBtn" :loading="disableBtn" static />

			<div class="fields__item text-center">
				<button class="link" type="button" @click="isSignUp = true">Регистрация</button>
			</div>
		</div>
		<div v-show="isSignUp">
			<div class="card__header">
				<h4 class="card__title text-center">Регистрация</h4>
			</div>
			<div class="fields__item">
				<button @click="$root.OAuth('vkontakte')" class="btn btn--outline btn--vk btn--block">
					<svg class="btn__icon" height="14" width="14">
						<use href="#svg-icon-vk"></use>
					</svg>
					<span>Вконтакте</span>
				</button>
			</div>
			<div class="fields__item fields__row">
				<div class="fields__item">
					<button @click="$root.OAuth('telegram')" class="btn btn--outline btn--tg btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-tg"></use>
						</svg>
						<span>Telegram</span>
					</button>
				</div>
				<div class="fields__item">
					<button @click="$root.OAuth('google')" href="#" class="btn btn--outline btn--google btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-google"></use>
						</svg>
						<span>Google</span>
					</button>
				</div>
			</div>
			<div class="fields__item fields__row">
				<div class="fields__item">
					<button @click="$root.OAuth('mailru')" class="btn btn--outline btn--mailru btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-mailru"></use>
						</svg>
						<span>Mail.ru</span>
					</button>
				</div>
				<div class="fields__item">
					<button @click="$root.OAuth('yandex')" class="btn btn--outline btn--yandex btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-yandex"></use>
						</svg>
						<span>Yandex</span>
					</button>
				</div>
			</div>
			<div class="fields__item small text-muted">
				Авторизуясь, вы соглашаетесь с <a href="terms" target="_blank" rel="noopener noreferrer">Правилами
					сайта</a>
			</div>

			<div class="form-note text-center">
				Есть аккаунт? <button class="link" type="button" @click="isSignUp = false">Войти</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {nextTick} from "vue";
    import VueRecaptcha from './../../components/googlerecaptcha/GoogleReCaptcha.vue';
	import Loader from "../blocks/Loader.vue";

    export default {
        components: {
			Loader,
            VueRecaptcha
        },
        data() {
            return {
                username: '',
                password: '',
                errors: {
                    show: false,
                    message: ''
                },
                disableBtn: false,
                vktest: '',
                isSignUp: false,
                gRecaptchaResponse: null,
            }
        },
        mounted() {
            this.rescaleCaptcha();
			window.addEventListener('resize', this.rescaleCaptcha);
        },

		unmounted() {
			window.removeEventListener('resize', this.rescaleCaptcha);
		},
		methods: {
			async rescaleCaptcha() {
				await nextTick();
				if (!this.$refs['recaptcha']) return
				let width = this.$refs['recaptcha'].$el.parentElement.clientWidth;
				let scale;
				if (width < 304) {
					scale = width / 304;
				} else {
					scale = 1.0;
				}
				this.$refs['recaptcha'].$el.style.transform = 'scale(' + scale + ')';
			},

            login() {
                if (!this.gRecaptchaResponse) {
                    return this.$toast.error('Необходимо пройти капчу');
                }

                if (!this.username) {
                    return this.$toast.error('Введите имя пользователя');
                }

                if (!this.password) {
                    return this.$toast.error('Введите пароль');
                }

                this.disableBtn = true;

                this.$root.graphql.getLoginUser({
                    username: this.username,
                    password: this.password,
                    recaptcha: this.gRecaptchaResponse
                }).then(res => {
                    const token = res.token;

                    if (token) {
                        this.$root.setAuthToken(token);
                        this.$root.getUser();
                        this.$root.recordUserData();
                    }

                    this.disableBtn = false;
                }).catch(error => {
                    this.disableBtn = false;
                    this.$toast.error(this.$root.graphql.getError(error));
                    this.$cookie.delete('token');
                    this.onCaptchaExpired();
                });
            },
            onCaptchaVerified(response) {
                this.gRecaptchaResponse = response;
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset()
            }
        }
    }
</script>